/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

export const HeaderContainer = styled.div`
  align-items: center;
  display: flex;

  & > * {
    margin-right: ${gridSize()}px;
  }

  ${media.upToMedium(`
    flex-wrap: wrap;

      & > * {
        margin-bottom: ${gridSize()}px;
      }
  `)};
`;
